import { render } from "./PublicServiceDashboard.vue?vue&type=template&id=52b2334c&scoped=true"
import script from "./PublicServiceDashboard.vue?vue&type=script&lang=js"
export * from "./PublicServiceDashboard.vue?vue&type=script&lang=js"

import "./PublicServiceDashboard.vue?vue&type=style&index=0&id=52b2334c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b2334c"]])

export default __exports__